import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-008267e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "RenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击开始播放后，网格会按顺序闪烁红色和蓝色格子。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请在全部闪烁结束后，按顺序点击所有红色格子出现的位置。", -1));
const _hoisted_5 = {
  class: "review-line"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "正确答案", -1));
const _hoisted_7 = {
  class: "review-items"
};
const _hoisted_8 = {
  key: 0,
  class: "review-line"
};
const _hoisted_9 = {
  key: 0,
  class: "review-items"
};
const _hoisted_10 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_ColorGridMemory = _resolveComponent("ColorGridMemory");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt24"
  }, {
    default: _withCtx(() => [_createVNode(_component_ColorGridMemory, {
      timeline: $props.data.timeline,
      size: $props.data.gridSize,
      "show-ms": $options.showMs,
      "gap-ms": $options.gapMs,
      "review-mode": $props.reviewMode,
      "review-answer": $props.review?.answer,
      "auto-play-signal": $data.replayTick,
      onAnswer: $options.onAnswer
    }, null, 8, ["timeline", "size", "show-ms", "gap-ms", "review-mode", "review-answer", "auto-play-signal", "onAnswer"])]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      onClick: $options.replayTimeline
    }, {
      default: _withCtx(() => [_createTextVNode("重新播放闪烁流程")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "review-block mt24"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.correctAnswers, (cell, index) => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: `right_${index}`,
        type: "info"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString($options.formatCell(cell)), 1)]),
        _: 2
      }, 1024);
    }), 128))])]), $props.review ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", {
      class: "review-label",
      style: _normalizeStyle({
        color: $props.review.result ? '#27ae60' : '#e74c3c'
      })
    }, "您的答案", 4), $options.reviewAnswers.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reviewAnswers, (cell, index) => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: `review_${index}`,
        type: $options.correctAnswers[index] === cell ? 'success' : 'danger'
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString($options.formatCell(cell)), 1)]),
        _: 2
      }, 1032, ["type"]);
    }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_10, "未作答"))])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}